// extracted by mini-css-extract-plugin
export const allZero = "VerticalBarChart__allZero__kn3-+";
export const atlasGrotesk = "'AtlasGrotesk'";
export const axis = "VerticalBarChart__axis__f7awY";
export const bar = "VerticalBarChart__bar__tnYea";
export const barLabel = "VerticalBarChart__barLabel__0E+66";
export const barValue = "VerticalBarChart__barValue__Hrx2x";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const member = "VerticalBarChart__member__XTwro";
export const negative = "VerticalBarChart__negative__z0lm1";
export const others = "VerticalBarChart__others__31-9u";
export const peers = "VerticalBarChart__peers__UlkgA";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const verticalBarChart = "VerticalBarChart__verticalBarChart__f5-dm";
export const verticalBarChartInner = "VerticalBarChart__verticalBarChartInner__POOXb";
export const zeroValue = "VerticalBarChart__zeroValue__16ctD";